module.exports = __webpack_public_path__ + "img/bannerBlue.c5b390bd.jpg";